import React, { Component } from "react";

import mixpanel from "../../../../../lib/mixPanel";

var configs = require("../../../../../../public/config.json");

export default class UseLocalePoints extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectAmount: props.points,
      addManually: false
    };
    mixpanel.track("Use Points Screen", {
      _source: "Checkout"
    });
  }
  handleUsePoints = () => {
    let { selectAmount } = this.state;
    selectAmount = parseInt(selectAmount)
    const { closeDefaultStatus, calculatedTotal, pointsAmount } = this.props;

    const pointsValue = parseInt(selectAmount) * configs.ptsToGbp;
    const parsedTotal =
      parseFloat(calculatedTotal) + pointsAmount * configs.ptsToGbp;
    const amount =
      (parseFloat(parsedTotal) < pointsValue &&
        parseFloat(parsedTotal) / configs.ptsToGbp) ||
      selectAmount;
    const points = {
      pointsAmount: amount
    };
    closeDefaultStatus("useLocalePoints", points);
  };
  handleChangeAmount = event => {
    event.preventDefault();
    const { points } = this.props;
    this.setState(
      {
        selectAmount: event.target.value
      },
      () => {
        if (points < this.state.selectAmount) {
          this.setState({ selectAmount: points });
        }
      }
    );
  };
  render() {
    const { closeDefaultStatus, points, pointsAmount } = this.props;
    const { selectAmount, addManually } = this.state;
    return (
      <React.Fragment>
        <div>
          <div className="modal-bg" />
          <div className="modal">
            {/* Header */}
            <div className="head-general with-back">
              <a />
              <h4>Local E eCoins</h4>
              <a
                onClick={() => closeDefaultStatus("useLocalePoints")}
                className="close"
              >
                <icon className="icon icon-close" />
              </a>
            </div>
            {/* Header */}
            <div className="modal-body">
              <div className="row center-sm">
                <div className="col-sm-6">
                  <div className="use-local-points white-bg">
                    <div className="head">
                      <p>Use Local E eCoins</p>
                      <p className="bold">
                        You have {points} eCoins (£
                        {parseFloat(points * configs.ptsToGbp).toFixed(2)})
                      </p>
                    </div>
                    <p>£1.00={1 / configs.ptsToGbp} eCoins</p>
                    <div>
                      <ul>
                        <li
                          onClick={() =>
                            this.setState({
                              addManually: false,
                              selectAmount: points
                            })
                          }
                          className="d-flex justify-content-between align-items-center"
                        >
                          <a
                            className={`d-flex justify-content-between align-items-center ${(!addManually &&
                              typeof addManually === "boolean" &&
                              "active") ||
                              ""}`}
                          >
                            Use all
                            {(!addManually &&
                              typeof addManually === "boolean" && (
                                <div>
                                  <div className="visible-xs">
                                    <icon className="icon icon-ok-green" />
                                  </div>
                                  <div className="hide-xs">
                                    <icon className="icon icon-okay-2" />
                                  </div>
                                </div>
                              )) || <noscript />}
                          </a>
                        </li>
                        <li
                          onClick={() =>
                            this.setState({
                              addManually: true,
                              selectAmount: 0
                            })
                          }
                          className="d-flex justify-content-between align-items-center"
                        >
                          <a
                            className={`d-flex justify-content-between align-items-center ${(typeof addManually ===
                              "boolean" &&
                              addManually &&
                              "active") ||
                              ""}`}
                          >
                            Select Amount
                            {(typeof addManually === "boolean" &&
                              addManually && (
                                <div>
                                  <div className="visible-xs">
                                    <icon className="icon icon-ok-green" />
                                  </div>
                                  <div className="hide-xs">
                                    <icon className="icon icon-okay-2" />
                                  </div>
                                </div>
                              )) || <noscript />}
                          </a>
                        </li>
                      </ul>
                      {(addManually && (
                        <div className="enter-input">
                          <input
                            type="number"
                            onKeyPress={evt => {
                              if (
                                (evt.which != 8 &&
                                  evt.which != 0 &&
                                  evt.which < 48) ||
                                evt.which > 57
                              ) {
                                evt.preventDefault();
                              }
                            }}
                            className="form-control"
                            placeholder="Enter number of eCoins"
                            onChange={this.handleChangeAmount}
                            defaultValue={pointsAmount || ""}
                            value={selectAmount || ""}
                          />
                        </div>
                      )) || <noscript />}
                    </div>
                  </div>
                  <div className="use-buttons">
                    <button
                      className={`btn btn-${(selectAmount && "blue") ||
                        "gray"}`}
                      onClick={this.handleUsePoints}
                      disabled={!selectAmount}
                    >
                      Apply
                    </button>
                    <button
                      className="btn btn-gray"
                      onClick={() => closeDefaultStatus("useLocalePoints")}
                    >
                      Cancel
                    </button>
                  </div>
                  {/* .use-buttons */}
                </div>
              </div>
              {/* .row */}
            </div>
            {/* .modal-body */}
          </div>
          {/* .modal */}
        </div>
      </React.Fragment>
    );
  }
}
